<template>
  <section class="container-cotizador">
    <CotizarHead :progressbar="steps.progressBar" />
    <DataInit />
    <hr />
    <form @submit="sendForm" class="mb-5">
      <section>
        <h3 class="subtitle">El plan es para:</h3>
        <PlanFor @change="updatePlanFor" />
      </section>

      <hr v-if="!this.isNoDocente" />
      <template v-if="this.payload.personPlanFor !== '' && !this.isNoDocente">
        <div class="container-fluid">
          <div class="is-flex is-mobile">
            <div>
              <JobIn
                @change="updatePJobIn"
                :condition="this.steps.btnContinueJobIn"
              />
            </div>
          </div>
        </div>
      </template>

    


       <ul class="input-ul" v-if="payload.personJobIn.option == 'opc-workDependency'">
        <li><h3 class="subtitle mb-0">Mi ingreso mensual bruto es de $ </h3></li>
        <li>
          <input
            type="number"
            required
            class="input"
            v-model= payload.personInputPrices
          />
        </li>
    
      </ul>

      <ul class="input-ul" v-if="payload.personPlanFor === 'dos' || payload.personPlanFor === 'opc-my-partner-son'">
        <li><h3 class="subtitle mb-0">Mi pareja tiene</h3></li>
        <li>
          <input
            type="number"
            required
            class="input"
            v-model="payload.personPartnerAge"
          />
        </li>
        <li><h3 class="subtitle mb-0">años.</h3></li>
      </ul>


      <ul class="input-ul" v-if="payload.personPlanFor === 'opc-my-son' || payload.personPlanFor === 'opc-my-partner-son'">
        <li><h3 class="subtitle mb-0">Tengo</h3></li>
        <li>
          <input
            type="number"
            required
            class="input"
            v-model="payload.cantSons"
            
          />
        </li>
        <li><h3 class="subtitle mb-0">hijo/s</h3></li>
      </ul>

      <div v-if="!this.steps.btnContinueJobIn" class="temporal-space"></div>

      <!-- hasta aca van las opciones -->

      <div
        v-if="
          this.payload.personJobIn.option == 'opc-workDependency' &&
          this.steps.btnContinueJobIn &&
          !this.steps.btnContinueWD
        "
      >
        <button @click="btnWDContinue" class="button is-info mt-3">
          Continuar
        </button>
      </div>
      <!-- NewsLetter -->

      <template
        v-if="this.payload.personPlanFor != '' && this.steps.btnContinueJobIn"
      >
        <template v-if="this.isNoDocente">
          <hr v-if="this.payload.personPlanFor != 'opc-my'" />
          <NewsLetter @change="updateNewsletterData" />
          <button class="button is-info" type="submit">Finalizar</button>
        </template>

        <template
          v-if="
            this.payload.personJobIn.option == 'opc-adherente' ||
            this.payload.personJobIn.option == 'opc-monotributista'
          "
        >
          <hr />
          <NewsLetter @change="updateNewsletterData" />
          <button class="button is-info" type="submit">Finalizar</button>
        </template>

        <template v-if="this.steps.btnContinueWD">
          <hr />
          <NewsLetter @change="updateNewsletterData" />
          <button class="button is-info" type="submit" id="finalizar">
            Finalizar
          </button>
        </template>
      </template>
    </form>
  </section>
</template>

<script>
import CotizarHead from "./../components/cotizar/CotizarHead";
import DataInit from "./../components/cotizar/DataInit";
import PlanFor from "./../components/cotizar/PlanFor";
import JobIn from "./../components/cotizar/JobIn";

import NewsLetter from "./../components/cotizar/NewsLetter";

import axios from "axios";
export default {
  name: "Cotizar",
  components: {
    CotizarHead,
    DataInit,
    PlanFor,
    JobIn,

    NewsLetter,
  },
  metaInfo: {
    title: "Cotizador",
  },
  beforeCreate() {
    // resetea los campos de este form con los del primer form
    //preguntar
    let beforeForm = this.$store.getters.getInitForm;
    if (beforeForm.name === "") this.$router.push({ name: "Home" });
  },
  updated() {
    window.scroll(0, window.innerHeight);
  },
  data() {
    return {
      responseData: null,
      steps: { progressBar: 10, btnContinueJobIn: true, btnContinueWD: false },
      isNoDocente: this.$store.getters.getInitForm.noDocente,
      payload: {
        leadID: -1,
        person: this.$store.getters.getInitForm,
        personPlanFor: "",
        personJobIn: {},
        personInputPrices: { my: "" },
        personSonsData: false,
        personPartnerAge: "",
        cantSons: ""
      },
    };
  },
  created() {
    if (this.isNoDocente) this.payload.personJobIn.option = "none";
  },
  methods: {
    removeTilde(str) {
      return String(str)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    // Send form to plan page
    sendForm(e) {
      e.preventDefault();
     const currentDate = new Date();
     this.payload.year = currentDate.getFullYear();
     this.payload.month = currentDate.getMonth() + 1;
      axios({
        method: "post",
        url: "https://api.osfatun.com.ar/api/v1/planes",
        //url: "http://osfatunapi2.test/api/v1/planes",
        data: this.payload,
      })
        .then(({ data }) => {
          this.responseData = data;
          //console.log("Response data:", data);

          this.$router.push({
            name: "Plan",
            params: { responseData: { data: data } },
          });
        })
        .catch((err) => {
          console.log("Error to send lead \n" + err);
        });

    },

    btnWDContinue(e) {
      e.preventDefault();
      this.steps.btnContinueWD = true;
    },
    // Updates
    updatePlanFor(value) {
      this.payload.personPlanFor = value;
      this.steps.btnContinueJobIn = true;
      console.log(this.payload.personPlanFor);
    },
    updatePJobIn(value) {
      this.payload.personJobIn = value;
      //console.log(this.payload.personJobIn.option);
    },
    
  },
};
</script>

<style scoped>
main {
  background-color: #f3f3f3;
  color: #00738f;
}
.container-cotizador {
  max-width: 83%;
  margin: 0 auto;
}
h3.subtitle {
  font-size: 25px;
  color: #00738f;
  margin-bottom: 30px;
}
hr {
  background-color: gray;
  height: 1px;
  margin: 3.5rem 0;
}
.temporal-space {
  height: 40px;
}
button {
  width: 195px;
  max-width: 195px !important;
  background: #00758f !important;
  color: #fff;
  /* font-size: 24px; */
  color: #ffffff;
  display: block;
  text-transform: uppercase;
  border-radius: 0;
}
@media screen and (max-width: 480px) {
  hr {
    margin: 2.5rem 0;
  }
  .container-cotizador {
    max-width: 100%;
  }
  .is-flex {
    display: block !important;
    max-width: 90%;
    margin: 0 auto;
  }
  h3.subtitle {
    text-align: center;
  }
  button.button {
    max-width: 50%;
    width: 100%;
    margin: 0 auto;
    display: block;
    text-align: center;
  }
}
.input-ul {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 10px;
}
.input-ul li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.input-ul li:last-child {
  margin-right: 0;
}

input {
  background-color: transparent;
  border-radius: 0;
  border: 0;
  border-bottom: 3px solid #fbaf33;
}

select {
  border-radius: 0;
  border: 0;
  color: #00738f;
  border-bottom: 3px solid #fbaf33;
}
.subtitle {
  color: #00738f;
  font-size: 24px;
  font-weight: bold;
}
.input-ul li:first-child,
.input-ul li:last-child {
  font-size: 24px;
  color: #00758f;
}

input[type="text"],
input[type="email"],
input[type="number"] {
  border-radius: 0;
  border: 0;
  border-bottom: 3px solid #fbaf33;
  width: 100px;
}
</style>
